import { IListOptions } from 'devextreme-react/list';
import React from 'react';
import * as S from './list-selection.style';

export const ListSelection: React.FunctionComponent<IListOptions> = listSelectionProps => (
  <S.ListSelection {...listSelectionProps} />
);
